import React from 'react';
import { connect } from 'react-redux';
import { trans } from '../../../../localization';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import NowCheckbox from '../../../../components/Common/NowCheckbox';
import { UNSET_DEFAULT_VALUE } from '../../../../constants/constants';

class TableRejectOrderModal extends React.Component {
  state = { selectedReasonId: this.props.defaultReasonId };
  render() {
    const { isOpenDialog, onClose, submitRejectReason, rejectReasons } = this.props;
    const { selectedReasonId } = this.state;
    return (
      <Modal isOpen={isOpenDialog} width="400px" className="reject-order">
        <ModalHeader>{trans('mod_why_cancel_the_order')}</ModalHeader>
        <ModalBody className="padding-0">
          <ul className="list-reject-reason">
            {rejectReasons.map(reason => (
              <li className="item row align-items-center" key={reason.id}>
                <NowCheckbox
                  value={reason.id === selectedReasonId}
                  name={reason.name}
                  onChange={() =>
                    this.setState({ selectedReasonId: reason.id })
                  }
                />
              </li>
            ))}
          </ul>
        </ModalBody>
        <ModalAction>
          <ModalButton type="cancel" onClick={onClose}>
            {trans('mod_go_back')}
          </ModalButton>
          <ModalButton onClick={() => submitRejectReason(selectedReasonId)}>
            {trans('send')}
          </ModalButton>
        </ModalAction>
      </Modal>
    );
  }
}

function getDefaultReasonId(rejectReasons) {
  if (rejectReasons.length === 0) {
    return UNSET_DEFAULT_VALUE;
  }
  const defaultReason =
    rejectReasons.find(reason => reason.is_default) || rejectReasons[0];
  return defaultReason.id;
}

const mapStateToProps = state => ({
  rejectReasons: state.app.tableMetaData.reject_reason_infos,
  defaultReasonId: getDefaultReasonId(
    state.app.tableMetaData.reject_reason_infos,
  ),
});

export default connect(mapStateToProps)(TableRejectOrderModal);



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/components/TableRejectOrderModal.jsx